var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{staticClass:"productCarousel",attrs:{"autoplay":true}},_vm._l((_vm.items),function(item){return _c('Slide',{key:item.id},[_c('ListItem',{attrs:{"carousel":true,"item":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }